import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { rem, Button, Spacer, AppView, CardView, ButtonGroup, SCREEN_BOTTOM_PADDING, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import Text from 'design-system/Text';
import { HEIGHT } from 'design-system/Button';
import { Avatar } from 'design-system/avatar';
import SectionHeader from 'design-system/SectionHeader';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { transferProductString } from 'features/invest/constants';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../constants';
const strings = {
    title: (t, type) => t === 'JISA'
        ? `Confirm your child’s Junior ISA provider`
        : `Confirm your ${transferProductString[type]} ${t} provider`,
    subTitle: (t, type) => t === 'JISA'
        ? 'Make sure this is the provider you’re transferring your child’s Junior ISA from'
        : `Make sure this is the provider you’re transferring your ${transferProductString[type]} ${t} from`,
    selectedProvider: 'Selected provider',
    searchAgain: 'Search again',
    continue: 'Continue',
};
const ProductTransferConfirmProviderScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    const colors = useColors();
    const { type, provider, accountId } = route.params;
    const accountType = accountId ? 'JISA' : 'ISA';
    const providerName = provider.shortName || provider.officialName;
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', 2 * HEIGHT + SCREEN_BOTTOM_PADDING + rem(16), paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const handleContinue = useCallback(() => {
        navigation.navigate('ProductTransferAccountReference', { type, provider, accountId });
    }, [type, provider, accountId]);
    return (<AppView withFrame={false}>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={contentContainerStyle}>
            <ScreenInfoHeader title={strings.title(accountType, type)} subTitle={strings.subTitle(accountType, type)}/>
            <SectionHeader horizontalMargins largeVerticalMargins style={styles.sectionHeader}>
              {strings.selectedProvider}
            </SectionHeader>
            <CardView noMarginTop noMarginBottom withPadding>
              <View style={styles.row}>
                <Avatar imageUrl={provider.imgUrl} name={providerName} color={colors.background.brandLight} fontColor={colors.text.textOnBrand} size={44}/>
                <Spacer.W16 />
                <View style={styles.flex}>
                  <Text Text-16>{providerName}</Text>
                </View>
              </View>
            </CardView>
          </Animated.ScrollView>

          <ButtonGroup type="floating">
            <Button brandReversed title={strings.searchAgain} onPress={navigation.goBack}/>
            <Button brand title={strings.continue} onPress={handleContinue}/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    sectionHeader: {
        marginTop: rem(8),
    },
    flex: {
        flex: 1,
    },
});
export default ProductTransferConfirmProviderScreen;
